import { useRef, useState, createElement, useEffect, } from 'react';
import classNames from 'classnames';
import { useThrottleFn } from 'ahooks';
import { ColorfulSidebar } from './colorful-sidebar';
import './index.scss';
const ColorfulIndexbar = props => {
    const { dataList, name, order, searchData, hotData, onClick, onIndexChange, display, ...otherProps } = props;
    const bodyRef = useRef(null);
    const [groups, setGroups] = useState();
    const classPrefix = `au-indexbar`;
    const classPrefixDisplay = display === 'block' ? 'au-indexbar-block' : 'au-indexbar-list';
    const [activeIndex, setActiveIndex] = useState('');
    const indexRef = useRef(null);
    useEffect(() => {
        if (dataList && order) {
            const groupedObj = dataList.reduce((grouped, item) => {
                const initial = item[order]?.charAt(0);
                if (!grouped[initial]) {
                    grouped[initial] = [];
                }
                grouped[initial].push(item);
                return grouped;
            }, {});
            const groupedArray = [];
            Object.keys(groupedObj)?.forEach(key => {
                const groupItem = {
                    title: key,
                    items: groupedObj[key],
                };
                groupedArray.push(groupItem);
            });
            groupedArray.sort((a, b) => {
                return a.title.localeCompare(b.title);
            });
            if (hotData) {
                const hotList = dataList.filter(data => Boolean(data[hotData]));
                if (hotList && hotList.length > 0) {
                    const hotItem = {
                        title: '热门',
                        items: hotList,
                        type: 'cate',
                    };
                    groupedArray.unshift(hotItem);
                }
            }
            if (searchData && searchData.length > 0) {
                const hisItem = {
                    title: '搜索',
                    items: searchData,
                    type: 'cate',
                };
                groupedArray.unshift(hisItem);
            }
            setGroups(groupedArray);
        }
    }, [dataList, order]);
    useEffect(() => {
        if (groups && groups.length > 0) {
            const firstItem = groups[0];
            const firstActive = firstItem.title || null;
            setActiveIndex(firstActive);
        }
    }, [groups]);
    function scrollTo(index) {
        const body = bodyRef.current;
        if (!body)
            return;
        const { children } = body;
        for (let i = 0; i < children.length; i++) {
            const panel = children.item(i);
            if (!panel)
                continue;
            const panelIndex = panel.dataset.index;
            if (panelIndex === index) {
                body.scrollTop = panel.offsetTop;
                setActiveIndex(index);
                activeIndex !== index && onIndexChange?.(index);
                return;
            }
        }
    }
    const { run: checkActiveIndex } = useThrottleFn(() => {
        const body = bodyRef.current;
        if (!body)
            return;
        const { scrollTop } = body;
        const elements = body.getElementsByClassName(`${classPrefix}-anchor`);
        for (let i = 0; i < elements.length; i++) {
            const panel = elements.item(i);
            if (!panel)
                continue;
            const panelIndex = panel.dataset.index;
            if (!panelIndex)
                continue;
            if (panel.offsetTop + panel.clientHeight - 35 > scrollTop) {
                setActiveIndex(panelIndex);
                activeIndex !== panelIndex && onIndexChange?.(panelIndex);
                return;
            }
        }
    }, { wait: 50, trailing: true, leading: true });
    const handleOnclick = (val) => {
        if (onClick) {
            onClick(val);
        }
    };
    const handleGetStyle = () => {
        const refDom = indexRef.current;
        if (!refDom)
            return { height: '100vh' };
        const rect = refDom.getBoundingClientRect();
        const sliderOffsetTop = `${rect.top}px`;
        return { height: `calc(100vh - ${sliderOffsetTop})` };
    };
    return (createElement("div", { style: handleGetStyle() },
        createElement("div", { className: classNames(`${classPrefix}`, `${classPrefix}-sticky`, `${classPrefixDisplay}`), ...otherProps, ref: indexRef },
            createElement(ColorfulSidebar, { indexItems: groups?.map(item => { return item?.title; }), activeIndex: activeIndex, onActive: index => {
                    scrollTo(index);
                } }),
            createElement("div", { className: `${classPrefix}-body`, ref: bodyRef, onScroll: checkActiveIndex }, groups?.map((groupItem, index) => (createElement("div", { key: index, "data-index": groupItem?.title, className: `${classPrefix}-anchor` },
                createElement("div", { className: `${classPrefix}-anchor-title` }, groupItem?.title || index),
                createElement("div", { className: `${classPrefix}-anchor-content ${groupItem.type ? `${classPrefix}-anchor-cate` : ""}` }, groupItem?.items?.map((item, subIndex) => (createElement("div", { className: `${classPrefix}-list-item`, key: subIndex, onClick: () => { handleOnclick(item); } },
                    createElement("div", { className: `${classPrefix}-list-item-inner` },
                        createElement("div", { className: `${classPrefix}-list-item-name` }, typeof item === "string" ? item : item[name])))))))))))));
};
ColorfulIndexbar.displayName = 'ColorfulIndexbar';
export default ColorfulIndexbar;
